
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from "@/integrations/supabase/client";
import { getErrorMessage } from './authErrorHandler';

export const useSocialAuthHandler = () => {
  const [googleLoading, setGoogleLoading] = useState(false);
  const { toast } = useToast();

  // Google login with Supabase
  const handleGoogleLogin = async () => {
    setGoogleLoading(true);
    
    try {
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          }
        }
      });
      
      if (error) throw error;
      
      // No need for further handling as the user will be redirected to Google
    } catch (error: any) {
      console.error("Google login error:", error);
      
      toast({
        title: "Google login failed",
        description: getErrorMessage(error),
        variant: "destructive",
      });
      
      setGoogleLoading(false);
    }
  };

  return {
    googleLoading,
    handleGoogleLogin
  };
};
